var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccRecover(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H28C34.3513 0.5 39.5 5.64873 39.5 12V28C39.5 34.3513 34.3513 39.5 28 39.5H12C5.64873 39.5 0.5 34.3513 0.5 28V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_228_1441)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H28C34.3513 0.5 39.5 5.64873 39.5 12V28C39.5 34.3513 34.3513 39.5 28 39.5H12C5.64873 39.5 0.5 34.3513 0.5 28V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_228_1441)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_228_1441",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 8H8V32H32V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_228_1441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0002 30.7502C22.7302 30.7502 22.4802 30.6002 22.3502 30.3702C22.2202 30.1302 22.2202 29.8502 22.3602 29.6102L23.4102 27.8602C23.6202 27.5002 24.0902 27.3902 24.4402 27.6002C24.8002 27.8102 24.9102 28.2702 24.7002 28.6302L24.4302 29.0802C27.1902 28.4302 29.2602 25.9502 29.2602 22.9902C29.2602 22.5802 29.6002 22.2402 30.0102 22.2402C30.4202 22.2402 30.7602 22.5802 30.7602 22.9902C30.7502 27.2702 27.2702 30.7502 23.0002 30.7502Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17.75C9.59 17.75 9.25 17.41 9.25 17C9.25 12.73 12.73 9.25 17 9.25C17.27 9.25 17.52 9.4 17.65 9.63C17.78 9.87 17.78 10.15 17.64 10.39L16.59 12.14C16.38 12.49 15.92 12.61 15.56 12.39C15.21 12.18 15.09 11.72 15.31 11.36L15.58 10.91C12.81 11.56 10.75 14.04 10.75 17C10.75 17.41 10.41 17.75 10 17.75Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8 20.6292V23.5692C22.8 26.0192 21.82 26.9992 19.37 26.9992H16.43C13.98 26.9992 13 26.0192 13 23.5692V20.6292C13 18.1792 13.98 17.1992 16.43 17.1992H19.37C21.82 17.1992 22.8 18.1792 22.8 20.6292Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.569 13H20.629C18.219 13 17.239 13.96 17.209 16.32H19.369C22.309 16.32 23.669 17.69 23.669 20.62V22.78C26.039 22.75 26.989 21.77 26.989 19.36V16.43C26.999 13.98 26.019 13 23.569 13Z",
    fill: "#34D399"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_228_1441",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_228_1441",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 34.7917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccRecover);
export default __webpack_public_path__ + "static/media/accRecover.b93474e8598554ac289594a7c62c7322.svg";
export { ForwardRef as ReactComponent };